import React, { useContext, useEffect, useState } from 'react'
import Select from "react-select"
import 'react-datepicker/dist/react-datepicker.css';
import { Icon } from '@iconify/react';
import { addcontext } from '../../ContextShare/ContextShare';
import { FiterDashBoardAdmin, GetKlaListForSearchFilter, GetSessionListForSearchFilter, GetSessionListForSearchFilterWithKla, HomeProgressBar, publishVideos } from '../../Services/allApi';
import HighlightVideosList from './HighlightVideosList';
import TagVideoList from './TagVideoList';
import ProgressChart from './ProgressChart';
import InfoIcon from '../../Components/InfoIcon'
import AddNewSpeaker from './AddNewSpeaker';
import EditHighlights from './EditHighlights';
import { useNavigate } from 'react-router-dom';
import SyncLoader from "react-spinners/SyncLoader";
import '../loaderStyles.css'
import CarousalImage from './CarousalImage';
import FooterLinks from './FooterLinks';
import SocialMedia from './SocialMedia';
import DomainName from './DomainName';
import { toast, ToastContainer } from 'react-toastify';

function Home() {
    const { addVideo, setAddVideo } = useContext(addcontext)
    const { tableSelectedFromSidebar, settableSelectedFromSidebar } = useContext(addcontext)
    const { initalDateVideoAddPage, setinitalDateVideoAddPage } = useContext(addcontext)
    const [token, setToken] = useState()
    const [progressData, setProgressData] = useState([])
    const [errorFilterMessage, seterrorFilterMessage] = useState()
    const navigate = useNavigate('')
    const handleVideoAdd = (date) => {
        setinitalDateVideoAddPage(date); // Set the initial date for the video upload page
        console.log(date);
        settableSelectedFromSidebar('video')
        navigate('/octobersky/video')
        setAddVideo(true)
    }
    const [selectedOptionKla, setSelectedOptionKla] = useState(null);
    const [selectedOptionsession, setSelectedOptionsession] = useState(null);
    const [klaListF, setKlaListF] = useState([]);
    const [sessionListF, setSessionListF] = useState([]);
    const [dateForTagVideo, setdateForTagVideo] = useState()
    const [isTagPageOpen, setIsTagPageOpen] = useState(false)
    const [isUpdateOpen, setisUpdateOpen] = useState(false)
    const [isUpdateOpen2, setisUpdateOpen2] = useState(false)
    const [navbar, setNavbar] = useState('hm')
    const [ProgressResult, setProgressResult] = useState()
    const [isSpeakerImageForm, setisSpeakerImageForm] = useState(false)
    const [socialMediaOpen, setsocialMediaOpen] = useState(false)
    const [progressRefresh,setProgressRefresh]=useState(1)
    // progress bar api
    const GetProgressList = async () => {
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await HomeProgressBar(reqHeader)
        seterrorFilterMessage(result?.response?.data?.message ?? 'No Results Found')
        setProgressResult(result)
        console.log(result);
        // console.log(JSON.stringify(result?.data, null, 2));
        setProgressData(result?.data?.video_dashboard_data)
    }

    useEffect(() => {
        setToken(sessionStorage.getItem('access_token'))
        if (token) {
            GetProgressList()
        }
        else {
            console.log('Token fetching failed');
        }
    }, [token])

    const handleTagAdd = (tagDate) => {
        setIsTagPageOpen(true)
        setdateForTagVideo(tagDate)
    }

    const handlePublish = async (DateTOPublish) => {
        const token = sessionStorage.getItem('access_token')
        const reqHeader = {
            "Content-Type": "application/json",
            "Authorization": `${token}`
        };
        const result = await publishVideos({ video_upload_date: DateTOPublish }, reqHeader)
        console.log(result);
        if(result?.status==200){
            toast.success("Publish successfull")
            setProgressRefresh(progressRefresh+1)
        }else{
            toast.error(result?.response?.data?.message ?? "Video publish failed")
        }
    }

    // ------------------------------------------FILTER IN VIDEO----------------------------------------------
    // Fetch KLA List for filter
    const klaListCallApiFilter = async () => {
        try {
            const result = await GetKlaListForSearchFilter();
            setKlaListF(result?.data?.data || []);
        } catch (error) {
            console.error("Error fetching KLA list for filter:", error);
        }
    };

    useEffect(() => {
        klaListCallApiFilter();
    }, []);

    const klaoptionsF = klaListF.map((item) => ({
        value: item.kla_id,
        label: `KLA${item.kla_no}`,
    }));

    // Fetch Session List
    const SessionListCallApiFilter = async () => {
        try {
            const resultSession = selectedOptionKla
                ? await GetSessionListForSearchFilterWithKla(selectedOptionKla.value)
                : await GetSessionListForSearchFilter();
            setSessionListF(resultSession?.data?.data || []);
        } catch (error) {
            console.error("Error fetching Session list for filter:", error);
        }
    };

    useEffect(() => {
        SessionListCallApiFilter();
    }, [selectedOptionKla]);

    const sessionoptionsF = sessionListF.map((item) => ({
        value: item.session_id,
        label: `Session${item.session_no}`,
    }));

    const handlechange = (option) => setSelectedOptionKla(option);
    const handlechangesession = (option) => setSelectedOptionsession(option);

    const FilterAdminVideoTable = async () => {
        const kla_id = selectedOptionKla?.value;
        const session_id = selectedOptionsession?.value;
        const obj = {};
        if (kla_id) obj.kla_id = kla_id;
        if (session_id) obj.session_id = session_id;
        try {
            const reqHeader = {
                "Content-Type": "application/json",
                "Authorization": `${token}`
            };
            const result = await FiterDashBoardAdmin(obj, reqHeader);
            setProgressData(result?.data?.video_dashboard_data || [])
            seterrorFilterMessage(result?.response?.data?.message ?? 'No Results Found')
            setProgressResult(result)
            console.log(result);
        } catch (error) {
            console.error("Error filtering archives data:", error);
        }
    };

    useEffect(() => {
        if (selectedOptionKla || selectedOptionsession) {
            FilterAdminVideoTable()
        }
    }, [selectedOptionKla, selectedOptionsession]);

    // ------------------------------------------FILTER IN VIDEO END----------------------------------------------

    const handleResetFilter = () => {
        setSelectedOptionKla(null)
        setSelectedOptionsession(null)
        GetProgressList()
    }

    return (
        <>
            {!isTagPageOpen ?
                <div className='flex flex-col w-full gap-3 ' >
                    <div className='bg-gray-100 rounded border flex md:flex-row flex-col md:justify-center gap-5 justify-start flex-wrap px-4 py-2'>
                        <ProgressChart result={ProgressResult} apicalled={errorFilterMessage} apicalledTwo={progressData} />
                    </div>
                    {!isTagPageOpen && (
                        <div className="w-full flex justify-center pb-2 border pt-2 bg-gray-100 rounded">
                            <div className="flex space-x-2">
                                <button
                                    className={`${navbar == 'hm' ? 'bg-green-500  text-gray-100' : 'bg-blue-gray-500 text-gray-100  hover:bg-blue-gray-700'} px-4 py-1 rounded-full border transition duration-300 ease-in-out hover:scale-105`}
                                    onClick={() => setNavbar('hm')}
                                >
                                    Home
                                </button>
                                <button
                                    className={`${navbar == 'fl' ? 'bg-green-500 text-gray-100' : 'bg-blue-gray-500 text-gray-100  hover:bg-blue-gray-700'} px-4 py-1 rounded-full border transition duration-300 ease-in-out hover:scale-105`}
                                    onClick={() => setNavbar('fl')}
                                >
                                    Featured video list
                                </button>
                                <button
                                    className={`${navbar == 'sp' ? 'bg-green-500 text-gray-100' : 'bg-blue-gray-500 text-gray-100  hover:bg-blue-gray-700'} px-4 py-1 rounded-full border transition duration-300 ease-in-out hover:scale-105`}
                                    onClick={() => setNavbar('sp')}
                                >
                                    Update speaker image
                                </button>
                                <button
                                    className={`${navbar == 'ci' ? 'bg-green-500 text-gray-100' : 'bg-blue-gray-500 text-gray-100  hover:bg-blue-gray-700'} px-4 py-1 rounded-full border transition duration-300 ease-in-out hover:scale-105`}
                                    onClick={() => setNavbar('ci')}
                                >
                                    Update carousal images
                                </button>
                                <button
                                    className={`${navbar == 'fo' ? 'bg-green-500 text-gray-100' : 'bg-blue-gray-500 text-gray-100  hover:bg-blue-gray-700'} px-4 py-1 rounded-full border transition duration-300 ease-in-out hover:scale-105`}
                                    onClick={() => setNavbar('fo')}
                                >
                                    Footeer links
                                </button>
                                <button
                                    className={`${navbar == 'dm' ? 'bg-green-500 text-gray-100' : 'bg-blue-gray-500 text-gray-100  hover:bg-blue-gray-700'} px-4 py-1 rounded-full border transition duration-300 ease-in-out hover:scale-105`}
                                    onClick={() => setNavbar('dm')}
                                >
                                    Domain Name
                                </button>
                            </div>
                        </div>
                    )}

                    {navbar == 'hm' && <div className=' rounded w-full flex md:flex-row flex-col md:justify-center gap-1 justify-start flex-wrap '>
                        {/* <ProgressChart/> */}
                        <div className='flex w-full flex-row justify-center gap-2 py-2 border rounded' >

                            <div className='flex flex-row justify-start items-center'>
                                {!selectedOptionKla && !selectedOptionsession && (<p className='me-2'>Current session</p>)}
                                <InfoIcon content={'To add new videos, create a sitting date. Go to Manage Sessions'} />
                            </div>

                            <div className='flex flex-row w-3/12  text-blue-400 '>
                                <Select
                                    placeholder='KLA'
                                    className='w-full'
                                    options={klaoptionsF}
                                    value={selectedOptionKla}
                                    onChange={handlechange}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        }),
                                    }} />
                            </div>

                            <div className='flex flex-row w-3/12 text-blue-400 '>
                                <Select
                                    placeholder='Session'
                                    className='w-full'
                                    options={sessionoptionsF}
                                    value={selectedOptionsession}
                                    onChange={handlechangesession}
                                    styles={{
                                        control: (baseStyles, state) => ({
                                            ...baseStyles,
                                            borderRadius: '0.5rem',
                                        }),
                                    }} />
                            </div>

                            {(selectedOptionKla || selectedOptionsession) && <div className='flex flex-col '>
                                <button onClick={handleResetFilter} className='flex flex-row gap-1 items-center rounded-lg w-full hover:bg-red-500 border text-red-500 hover:text-white border-red-500 h-9 px-2 transform duration-700 ease-in-out'>
                                    <span>Clear Filter</span>
                                    <Icon icon="bx:reset" />
                                </button>
                            </div>}
                        </div>

                        {/* show the progress */}
                        <div className='bg-white py-2 w-full'>
                            {progressData?.length > 0 ? progressData?.map((items) => (
                                <div className='p-2 w-full flex flex-row items-center gap-2 bg-success mb-2 rounded border justify-between'>

                                    <div>
                                        <span className='text-2xl w-20 font-bold text-blue-gray-900  '>{items?.date.split("-")[2]}-</span>
                                        <span className='text-lg w-20 text-gray-700'>{items?.date.split("-")[1]}-{items?.date.split("-")[0]}</span>
                                    </div>
                                    {/* video */}

                                    <div><div className='w-16 h-1 rounded' style={{ backgroundColor: '#228B22' }}></div></div>

                                    <div className='w-48 h-20 rounded-lg shadow-md border flex flex-col items-center p-4 bg-white transform transition-transform hover:scale-105'>

                                        <div className='flex flex-row justify-center items-center h-full w-full text-blue-gray-900'>
                                            <div><p className='me-2'>{items?.progress_bar[0]?.Video_upload_progress}</p></div>
                                            <div><p>Videos</p></div>
                                            <div><Icon icon="ph:file-video-light" className='text-xl ms-1' /></div>
                                        </div>
                                        <div className='flex flex-row justify-center gap-2 items-center w-full mt-1'>
                                            <div className='w-6 h-6 rounded-full '>

                                                {items?.progress_bar[0]?.Video_upload_status == 'True' ? <Icon icon="ep:success-filled" className={`w-full h-full `} style={{ color: `${items.progress_bar[0].colur_code}` }} />
                                                    :
                                                    <Icon icon="carbon:pending" className={`w-full h-full `} style={{ color: `${items.progress_bar[0].colur_code}` }} />
                                                }

                                            </div>
                                            {/* {items.progress_bar[0]?.Video_upload_status == 'True' ?
                                                <div> <p className={`text-xs `} style={{ color: `${items.progress_bar[0].colur_code}` }}>Completed</p></div>
                                                : */}
                                            <div className='flex text-xs'><button onClick={() => handleVideoAdd(items.date)} className='hover:bg-blue-500 text-blue-500 hover:text-white p-1 rounded'>Add video</button></div>
                                            {/* } */}

                                        </div>


                                    </div>

                                    {/* tag */}
                                    <div><div className={`w-16 h-1 rounded`} style={{ backgroundColor: `${items.progress_bar[2]?.colur_code}` }}></div></div>

                                    <div className='w-48 h-20 rounded-lg shadow-md border flex flex-col items-center p-4 bg-white transform transition-transform hover:scale-105'>

                                        <div className='flex flex-row justify-center items-between h-full w-full text-blue-gray-900'>
                                            <div><p className='me-2'>{items?.progress_bar[2]?.tags_progress}</p></div>
                                            <div><p>Tags</p></div>
                                            <div>
                                                {/* <Icon icon="oui:timeline" className='text-xl ms-1' /> */}
                                                <Icon icon="mingcute:tag-2-line" className='text-xl ms-1' />

                                            </div>
                                        </div>
                                        <div className='flex flex-row justify-center gap-2 items-center w-full mt-1'>

                                            <div className='w-6 h-6 rounded-full '>
                                                {items.progress_bar[2]?.tags_status == 'True' ? <Icon icon="ep:success-filled" className={`w-full h-full`} style={{ color: `${items.progress_bar[2].colur_code}` }} />
                                                    :
                                                    <Icon icon="carbon:pending" className='w-full h-full' style={{ color: `${items.progress_bar[2].colur_code}` }} />
                                                }
                                            </div>
                                            {items.progress_bar[2]?.tags_status == 'True' ?
                                                <div> <p className={`text-xs`} style={{ color: `${items.progress_bar[2].colur_code}` }}>Completed</p></div>
                                                :
                                                <div className='flex text-xs'><button className='hover:bg-blue-500 text-blue-500 hover:text-white p-1 rounded' onClick={() => handleTagAdd(items.date)}>Update tags</button></div>
                                            }
                                        </div>
                                    </div>

                                    {/* publish */}
                                    <div><div className={`w-16 h-1 rounded `} style={{ backgroundColor: `${items.progress_bar[1].colur_code}` }}></div></div>

                                    <div className='w-48 h-20 rounded-lg shadow-md border flex flex-col items-center p-4 bg-white transform transition-transform hover:scale-105'>

                                        <div className='flex flex-row justify-center items-between h-full w-full text-blue-gray-900'>
                                            <div><p className='me-2'>{items?.progress_bar[1]?.published_progress}</p></div>

                                            <div><p>Publish</p></div>
                                            <div><Icon icon="carbon:ibm-elo-publishing" className='text-xl ms-1' /></div>
                                        </div>
                                        <div className='flex flex-row justify-center gap-2 items-center w-full mt-1'>

                                            <div className='w-6 h-6 rounded-full '>
                                                {items.progress_bar[1]?.published_status == 'True' ? <Icon icon="ep:success-filled" className='w-full h-full' style={{ color: `${items.progress_bar[1].colur_code}` }} />
                                                    :
                                                    <Icon icon="carbon:pending" className='w-full h-full ' style={{ color: `${items.progress_bar[1].colur_code}` }} />
                                                }
                                            </div>
                                            {items.progress_bar[1]?.published_status == 'True' ?
                                                <div> <p className={`text-xs `} style={{ color: `${items.progress_bar[1].colur_code}` }}>Completed</p></div>
                                                :
                                                <div className='flex text-xs'><button onClick={() => handlePublish(items.date)} className='hover:bg-blue-500 hover:text-white p-1 rounded text-blue-500'>Publish now</button></div>
                                            }
                                        </div>
                                    </div>


                                    {/* overall status */}
                                    <div><div className={`w-16 h-1 rounded `} style={{ backgroundColor: `${items.progress_bar[3].complete_color_code}` }}></div></div>

                                    <div className='rounded flex flex-col items-center w-20'>

                                        <div className='flex flex-row justify-between items-center w-full'>
                                            <div className='w-10 h-10 rounded-full '>
                                                {items.progress_bar[3]?.complete == 'True' ? <Icon icon="ep:success-filled" className='w-full h-full' style={{ color: `${items.progress_bar[3].complete_color_code}` }} />
                                                    :
                                                    <Icon icon="carbon:pending" className='w-full h-full ' style={{ color: `${items.progress_bar[3].complete_color_code}` }} />
                                                }
                                            </div>
                                            <div> <p className={`text-xs `} style={{ color: `${items.progress_bar[3].complete_color_code}` }} >{items.progress_bar[3]?.complete == 'True' ? 'Completed' : 'Pending'}</p></div>
                                        </div>
                                    </div>


                                </div >
                            ))
                                :
                                <>
                                    {errorFilterMessage ?
                                        <div className='p-2 w-full flex flex-row items-center rounded  justify-center'>
                                            <h2 className='text-red-700 font-bold'>{errorFilterMessage ? errorFilterMessage : 'No Results Found'}</h2>
                                        </div>
                                        :
                                        //    loader
                                        <div className="flex justify-center items-center w-full h-full flex-col gap-5">
                                            <SyncLoader
                                                color="#3498db"
                                                loading={true}
                                                speedMultiplier={1}
                                            />
                                            <p className="loading-text flex flex-row items-center"><span>Loading please wait</span><Icon className='text-lg' icon="eos-icons:three-dots-loading" /></p>
                                        </div>
                                    }
                                </>
                            }
                        </div>
                    </div >}
                </div>
                :
                <div className=' w-full'>
                    <TagVideoList dateForTag={dateForTagVideo} setIsTagPageOpen={setIsTagPageOpen} />
                </div>
            }
            {navbar == 'fl' && <div className='flex flex-col rounded mt-2 pt-2 bg-gray-100 border border-blue-500'>
                <div className='flex flex-row justify-between '>
                    <h3 className='text-blue-700 text-xl font-bold mb-4 text-center ms-10'>Featured videos </h3>
                    <button className='bg-blue-500 hover:bg-blue-400 mb-4 px-4 py-1 rounded-full text-white me-10' onClick={() => setisUpdateOpen2(!isUpdateOpen2)}>{!isUpdateOpen2 ? 'Update Featured List' : 'Close'}</button>
                </div>
                {!isUpdateOpen2 && <div className=' p-2'><HighlightVideosList /></div>}
                {isUpdateOpen2 && <div className=' p-2'> <EditHighlights setisUpdateOpen2={setisUpdateOpen2} /></div>}
            </div>}
            {navbar == 'sp' && <div className='flex justify-center py-2'>
                <AddNewSpeaker setisSpeakerImageForm={setisSpeakerImageForm} />
            </div>}
            {navbar == 'ci' && <div className='flex justify-center p-2'>
                <CarousalImage />
            </div>}
            {navbar == 'dm' && <div className='flex justify-center p-2'>
                <DomainName />
            </div>}
            {navbar == 'fo' && <div className='flex justify-center flex-col gap-1'>
                <div className='flex  w-full justify-end '><button onClick={() => setsocialMediaOpen(!socialMediaOpen)} className='rounded hover:bg-green-500 text-green-500 border hover:text-white border-green-500 px-2 mt-1'>{socialMediaOpen ? 'Add quick links' : 'Add social media links'}</button></div>
                {socialMediaOpen ?
                    <SocialMedia />
                    :
                    <FooterLinks />}
            </div>}

            <ToastContainer
                position="top-center"
                autoClose={4000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                draggable
                pauseOnHover
                theme="light"
            />
        </>
    )
}

export default Home